<template>
	 <div class="section-partner">
                <div class="container">
                    <div class="section-subject">
                        <div class="title">
                            Partner
                        </div>
                        <div class="desc">
                            조직과 임직원이 꿈꾸는 성장, <br class="pc_hidden"><strong>이미 많은 고객사가 에듀윌과 함께하고 있습니다.</strong>
                        </div>
                    </div>
                    <ul class="pa_slider_vertical">

                        <li class="pa_item">
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/01_1/ci_01_220711.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/business/ci_01.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/business/ci_02.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/business/ci_03.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/business/ci_04.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/01_1/ci_02_220711.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/business/ci_05.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/business/ci_06.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/business/ci_07.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/business/ci_08.png" />
                        </li>
                        <li class="pa_item">
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/business/ci_09.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/business/ci_10.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/business/ci_11.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/business/ci_12.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/business/ci_13.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/business/ci_14.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/business/ci_15.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/business/ci_16.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/business/ci_17.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/business/ci_18.png" />
                        </li>
                        <li class="pa_item">
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/01_1/ci_03_220711.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/business/ci_19.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/business/ci_20.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/business/ci_21.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/01_1/ci_04_220711.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/business/ci_22.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/business/ci_23.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/business/ci_24.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/business/ci_25.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/business/ci_26.png" />

                        </li>
                        <li class="pa_item">
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/business/ci_27.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/business/ci_28.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/business/ci_29.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/business/ci_30.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/01_1/ci_05_220711.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/01_1/ci_06_220711.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/01_1/ci_07_220711.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/01_1/ci_08_220711.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/01_1/ci_09_220711.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/01_1/ci_10_220711.png" />

                        </li>
                        <li class="pa_item">
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/public/ci_01.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/public/ci_02.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/public/ci_03.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/public/ci_04.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/public/ci_05.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/public/ci_06.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/public/ci_07.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/public/ci_08.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/public/ci_09.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/public/ci_10.png" />
                        </li>
                        <li class="pa_item">
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/public/ci_11.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/public/ci_12.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/01_1/ci_11_220711.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/01_1/ci_12_220711.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/public/ci_13.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/public/ci_14.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/public/ci_15.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/public/ci_16.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/01_1/ci_13_220711.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/01_1/ci_14_220711.png" />
                        </li>
                        <li class="pa_item">
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/public/ci_17.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/public/ci_18.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/public/ci_19.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/public/ci_20.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/01_1/ci_15_220711.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/public/ci_21.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/public/ci_22.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/public/ci_23.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/public/ci_24.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/public/ci_25.png" />
                        </li>
                        <li class="pa_item">
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/public/ci_26.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/01_1/ci_17_220711.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/01_1/ci_16_220711.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/01_1/ci_18_220711.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/public/ci_27.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/public/ci_28.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/public/ci_29.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/public/ci_30.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/college/ci_61.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/01_2/ci_19_220711.png" />
                        </li>
                        <li class="pa_item">
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/01_2/ci_20_220711.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/college/ci_62.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/college/ci_63.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/college/ci_64.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/college/ci_65.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/01_2/ci_21_220711.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/01_2/ci_22_220711.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/college/ci_66.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/college/ci_67.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/college/ci_68.png" />
                        </li>
                        <li class="pa_item">
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/college/ci_69.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/college/ci_70.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/college/ci_71.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/college/ci_72.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/college/ci_73.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/01_2/ci_23_220711.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/college/ci_74.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/college/ci_75.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/college/ci_76.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/college/ci_77.png" />
                        </li>
                        <li class="pa_item">
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/01_2/ci_24_220711.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/college/ci_78.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/college/ci_79.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/college/ci_80.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/01_2/ci_25_220711.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/college/ci_81.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/college/ci_82.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/college/ci_83.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/college/ci_84.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/college/ci_85.png" />
                        </li>
                        <!-- <li>
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/college/ci_86.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/college/ci_87.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/college/ci_88.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/college/ci_89.png" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/partner/college/ci_90.png" />
                        </li> -->

                    </ul>
                </div>
            </div>
</template>
<script>

export default {
	name: "PartnerBanner",
	
	data() {
		return {}
	},
	
	computed: {
	},
	
	methods: {
	},
	
	created() {
	},
	beforeMount() {
	},
	mounted() {
		$(".pa_slider_vertical").simplyScroll({
			orientation: 'vertical',
			customClass: 'vert',
			speed: 1,
			pauseOnHover: true
		});
	},
}
</script>

<style scoped>

</style>
